module.exports = __webpack_public_path__ + "img/location.de9499ea.svg";